import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./core/services/store";
import ApiService from "./core/services/api.service";
//import MockService from "./core/mock/mock.service";
import { VERIFY_AUTH } from "./core/services/store/auth.module";
import { RESET_LAYOUT_CONFIG } from "@/core/services/store/config.module";

Vue.config.productionTip = false;

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
window.PerfectScrollbar = PerfectScrollbar;
import ClipboardJS from "clipboard";
window.ClipboardJS = ClipboardJS;

// Vue 3rd party plugins
import i18n from "./core/plugins/vue-i18n";
import vuetify from "./core/plugins/vuetify";
import "./core/plugins/portal-vue";
import "./core/plugins/bootstrap-vue";
import "./core/plugins/perfect-scrollbar";
import "./core/plugins/highlight-js";
import "./core/plugins/inline-svg";
import "./core/plugins/apexcharts";
import "./core/plugins/metronic";

import Toasted from "vue-toasted";

import VuePwaInstallPlugin from "vue-pwa-install";

Vue.use(VuePwaInstallPlugin);

Vue.use(Toasted);

/*import wb from "./registerServiceWorker";

Vue.prototype.$workbox = wb;*/

import { register } from "register-service-worker";

register(`${process.env.BASE_URL}service-worker.js`, {
  ready() {
    console.log(
      "App is being served from cache by a service worker.\n" +
        "For more details, visit https://goo.gl/AFskqB"
    );
    store.commit("changeSemaforo", "success");
    Vue.toasted.show("La aplicación esta lista para usarse offline", {
      duration: 5000,
      type: "success",
    });
  },
  registered() {
    console.log("Service worker has been registered.");
    // store.commit('changeSemaforo','warning');
  },
  cached() {
    console.log("Content has been cached for offline use.");
    // store.commit('changeSemaforo','warning');
  },
  updatefound() {
    console.log("New content is downloading.");
    store.commit("changeSemaforo", "warning");
  },
  updated() {
    console.log("New content is available; please refresh.");
    store.commit("changeSemaforo", "warning");
  },
  offline() {
    console.log(
      "No internet connection found. App is running in offline mode."
    );
    store.commit("changeSemaforo", "success");
    Vue.toasted.show("La aplicación esta en modo offline", {
      duration: 5000,
      type: "success",
    });
  },
  error(error) {
    console.error("Error during service worker registration:", error);
    store.commit("changeSemaforo", "danger");
    Vue.toasted.show(
      "Hubo un error al cargar la aplicación por favor actualice con conexión",
      {
        duration: 5000,
        type: "danger",
      }
    );
  },
});

import "@mdi/font/css/materialdesignicons.css";
//import "./registerServiceWorker";

// API service init
ApiService.init();

// Remove this to disable mock API
//MockService.init();

router.beforeEach((to, from, next) => {
  // Ensure we checked auth before each page load.
  Promise.all([store.dispatch(VERIFY_AUTH)]).then(next);

  // reset config to initial state
  store.dispatch(RESET_LAYOUT_CONFIG);
  // Scroll page to top on every route change
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
});

var app = new Vue({
  router,
  store,
  i18n,
  vuetify,
  data: {
    onLine: navigator.onLine, // initial status
  },
  render: (h) => h(App),
}).$mount("#app");

function updateConnectionStatus() {
  app.onLine = navigator.onLine; // this method
  store.dispatch("setStateNetwork", app.onLine);
}

store.dispatch("setStateNetwork", app.onLine);

window.addEventListener("online", updateConnectionStatus);
window.addEventListener("offline", updateConnectionStatus);
